import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/ui/Layout';
import PageHeader from '../../components/ui/PageHeader';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { useAuth } from '../../context/AuthContext';
import { hqWhoAmI, hqListMakes, hqSearchModels } from '../../lib/hqApi';

export default function HqDiagnostic() {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState(null);

  // Only org_admin can access
  if (userProfile && userProfile.role !== 'org_admin') {
    return (
      <Layout>
        <PageHeader title="Access denied" subtitle="This page is restricted to organisation administrators." />
        <div style={{ padding: 28 }}>
          <Button onClick={() => navigate('/dashboard')}>Back to dashboard</Button>
        </div>
      </Layout>
    );
  }

  const runTest = async (label, fn) => {
    setLoading(label); setResult(null); setError(null);
    try {
      const data = await fn();
      setResult({ label, data });
    } catch (err) {
      setError({ label, message: err.message });
    }
    setLoading(null);
  };

  return (
    <Layout>
      <PageHeader title="HQ diagnostic" subtitle="Internal — cross-project Cloud Functions test" />
      <div style={{ padding: 28 }}>
        <Card>
          <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 16, lineHeight: 1.6 }}>
            These buttons call HQ Cloud Functions from this Ops project, passing your Firebase Auth token for cross-project verification.
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            <Button size="sm" loading={loading === 'whoAmI'} onClick={() => runTest('whoAmI', () => hqWhoAmI())}>whoAmI</Button>
            <Button size="sm" loading={loading === 'listMakes'} onClick={() => runTest('listMakes', () => hqListMakes())}>listMakes</Button>
            <Button size="sm" loading={loading === 'searchModels'} onClick={() => runTest('searchModels', () => hqSearchModels('6r'))}>searchModels("6r")</Button>
          </div>

          {result && (
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6 }}>{result.label} →</div>
              <pre style={{ padding: 12, background: 'var(--color-bg-secondary)', borderRadius: 'var(--radius-md)', fontSize: 11, fontFamily: 'var(--font-mono)', overflow: 'auto', maxHeight: 400, margin: 0 }}>
                {JSON.stringify(result.data, null, 2).slice(0, 4000)}
              </pre>
            </div>
          )}

          {error && (
            <div style={{ marginTop: 16, padding: 12, background: 'var(--color-danger-light)', color: 'var(--color-danger)', borderRadius: 'var(--radius-md)', fontSize: 12 }}>
              {error.label} failed: {error.message}
            </div>
          )}
        </Card>
      </div>
    </Layout>
  );
}
